/* === Ask Angie === client-side UI + parser + multi-pass Shopify product matching */
(function () {
  'use strict';

  // ====== DOM HOOKS ======
  var fab = document.getElementById('ask-angie-fab');
  var heroBtn = document.getElementById('aa-hero-btn');
  var modal = document.getElementById('ask-angie-modal');
  if (!modal) return;

  var intro = document.getElementById('aa-intro');
  var listSection = document.getElementById('aa-list');
  var listRows = document.getElementById('aa-list-rows');
  var subtotalEl = document.getElementById('aa-subtotal');
  var matchCountEl = document.getElementById('aa-match-count');
  var inputForm = document.getElementById('aa-input-form');
  var inputEl = document.getElementById('aa-input');
  var sendBtn = document.getElementById('aa-send');
  var micBtn = document.getElementById('aa-mic');
  var hint = document.getElementById('aa-hint');
  var headPhoto = document.getElementById('aa-head-photo');
  var photos = headPhoto ? JSON.parse(headPhoto.getAttribute('data-photos') || '{}') : {};
  var chatForm = document.getElementById('aa-chat-form');
  var chatInput = document.getElementById('aa-chat-input');
  var chatLog = document.getElementById('aa-chat-log');
  var addCartBtn = document.getElementById('aa-add-cart');
  var orderNowBtn = document.getElementById('aa-order-now');
  var saveBtn = document.getElementById('aa-save-template');
  var startOverBtn = document.getElementById('aa-start-over');
  var templatesContainer = document.getElementById('aa-templates');
  var templatesList = document.getElementById('aa-templates-list');
  var suggestBox = document.getElementById('aa-list-suggest');

  var state = { rows: [] };

  function setMood(mood) {
    if (photos && photos[mood] && headPhoto) headPhoto.src = photos[mood];
  }

  function openModal() {
    // If empty (fresh open or after clear), show intro
    if (!state.rows.length) { if (intro) intro.hidden = false; if (listSection) listSection.hidden = true; }
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    setTimeout(function () { inputEl && inputEl.focus(); }, 250);
    renderTemplates();
    setMood('idle');
  }
  function closeModal() {
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
  if (fab) fab.addEventListener('click', openModal);
  if (heroBtn) heroBtn.addEventListener('click', openModal);
  modal.querySelectorAll('[data-aa-close]').forEach(function (el) { el.addEventListener('click', closeModal); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal.getAttribute('aria-hidden') === 'false') closeModal();
  });

  // ====== VOICE INPUT ======
  var SR = window.SpeechRecognition || window.webkitSpeechRecognition;
  var recognition = null;
  if (SR && micBtn) {
    recognition = new SR();
    recognition.continuous = false;
    recognition.interimResults = true;
    recognition.lang = 'en-US';
    recognition.onresult = function (e) {
      var text = '';
      for (var i = e.resultIndex; i < e.results.length; i++) text += e.results[i][0].transcript;
      if (!intro.hidden) inputEl.value = text;
      else chatInput.value = text;
    };
    recognition.onend = function () { micBtn.classList.remove('is-recording'); setMood('thinking'); };
    recognition.onerror = function () { micBtn.classList.remove('is-recording'); hint.textContent = 'Voice input not available. Try typing instead.'; };
    micBtn.addEventListener('click', function () {
      if (micBtn.classList.contains('is-recording')) recognition.stop();
      else {
        try {
          recognition.start();
          micBtn.classList.add('is-recording');
          setMood('listening');
          hint.textContent = 'Listening... tap mic again to stop.';
        } catch (e) {}
      }
    });
  } else if (micBtn) {
    micBtn.addEventListener('click', function () { hint.textContent = 'Your browser does not support voice input. Try Chrome or Edge.'; });
  }

  document.querySelectorAll('[data-aa-quick]').forEach(function (b) {
    b.addEventListener('click', function () {
      inputEl.value = b.getAttribute('data-aa-quick');
      inputForm.dispatchEvent(new Event('submit', { cancelable: true }));
    });
  });

  inputForm.addEventListener('submit', function (e) {
    e.preventDefault();
    var text = inputEl.value.trim();
    if (!text) return;
    submitOrder(text);
  });

  function submitOrder(text) {
    setMood('thinking');
    sendBtn.disabled = true;
    showStage(null);  // reset
    if (!window.AskAngieMAS) {
      console.error('[Ask Angie] MAS module not loaded');
      hint.textContent = 'Setup error — please refresh.';
      sendBtn.disabled = false;
      setMood('sorry');
      return;
    }
    window.AskAngieMAS.run(text, showStage).then(function (presented) {
      state.rows = presented.rows;
      sendBtn.disabled = false;
      intro.hidden = true;
      listSection.hidden = false;
      renderRows();
      maybeShowSuggest();
      hideStage();
      var matched = presented.rows.filter(function (r) { return r.matched; }).length;
      setMood(matched > 0 ? 'done' : 'sorry');
    }).catch(function (err) {
      console.warn('[Ask Angie] MAS error:', err);
      sendBtn.disabled = false;
      hint.textContent = 'Sorry — I had trouble with that. Try simpler phrasing or use the chips.';
      hideStage();
      setMood('sorry');
    });
  }

  // ====== 4-AGENT STAGE INDICATOR ======
  var STAGES = [
    { id: 'teacher',      icon: '🎯', label: 'Understanding your request' },
    { id: 'retrieval',    icon: '🔎', label: 'Searching the catalog' },
    { id: 'verification', icon: '✓',  label: 'Verifying matches' },
    { id: 'presentation', icon: '📋', label: 'Preparing your order' }
  ];
  function showStage(stageId, detail) {
    var box = document.getElementById('aa-stage-indicator');
    if (!box) {
      box = document.createElement('div');
      box.id = 'aa-stage-indicator';
      box.className = 'aa-stage';
      if (intro && intro.parentNode) {
        intro.parentNode.insertBefore(box, intro);
      }
    }
    if (!stageId) {
      box.innerHTML = '<div class="aa-stage__title">Ask Angie is working in 4 steps…</div>' +
        STAGES.map(function (s, i) {
          return '<div class="aa-stage__step" data-stage="' + s.id + '">' +
                 '<span class="aa-stage__num">' + (i + 1) + '</span>' +
                 '<span class="aa-stage__icon">' + s.icon + '</span>' +
                 '<span class="aa-stage__label">' + s.label + '</span>' +
                 '<span class="aa-stage__state" data-state="idle">…</span>' +
                 '</div>';
        }).join('');
      box.style.display = 'block';
      return;
    }
    var step = box.querySelector('[data-stage="' + stageId + '"]');
    if (!step) return;
    var stateEl = step.querySelector('.aa-stage__state');
    var labelEl = step.querySelector('.aa-stage__label');
    if (detail && detail.done) {
      step.setAttribute('data-state', 'done');
      stateEl.setAttribute('data-state', 'done');
      stateEl.textContent = '✓';
      if (detail.summary) labelEl.textContent = detail.summary;
    } else {
      step.setAttribute('data-state', 'active');
      stateEl.setAttribute('data-state', 'active');
      stateEl.textContent = '●';
      if (detail && detail.label) labelEl.textContent = detail.label;
    }
  }
  function hideStage() {
    var box = document.getElementById('aa-stage-indicator');
    if (box) setTimeout(function () { box.style.display = 'none'; }, 1500);
  }

  // ====== DEALER TERMINOLOGY SYNONYMS ======
  // Maps common dealer shorthand to the actual product titles in the store
  var SYNONYMS = [
    // Numbers — fractional notation matches actual product titles
    { test: /\b(5\.5|5\s*1\/2|5-1\/2)\s*(in|inch|inches)?\s*(numbers?)?\b/i, replacement: '5 1/2 windshield numbers' },
    { test: /\b(7\.5|7\s*1\/2|7-1\/2)\s*(in|inch|inches)?\s*(numbers?)?\b/i, replacement: '7 1/2 windshield numbers' },
    { test: /\b(9\.5|9\s*1\/2|9-1\/2)\s*(in|inch|inches)?\s*(numbers?)?\b/i, replacement: '9 1/2 windshield numbers' },
    { test: /\b(11\.5|11\s*1\/2|11-1\/2)\s*(in|inch|inches)?\s*(numbers?)?\b/i, replacement: '11 1/2 windshield numbers' },
    { test: /\b5'?s\b/i,  replacement: '5 1/2 windshield numbers' },
    { test: /\b7'?s\b/i,  replacement: '7 1/2 windshield numbers' },
    { test: /\b9'?s\b/i,  replacement: '9 1/2 windshield numbers' },
    { test: /\b11'?s\b/i, replacement: '11 1/2 windshield numbers' },
    { test: /\bwindshield (number|num) stickers?\b/i, replacement: 'windshield number stickers' },
    // Colors — catalog uses both "neon green" and "chartreuse" interchangeably
    { test: /\b(chartreuse|day[- ]glow green|fluor(escent)? green|hi[- ]?vis green)\b/i, replacement: 'neon green' },
    // Key tags
    { test: /\b(poly[- ]?tags?|polytags?|poly key)\b/i, replacement: 'key tags poly' },
    { test: /\bkey ?tags?\b/i, replacement: 'key tags' },
    // Slogans
    { test: /\bautomatic\b/i, replacement: 'automatic windshield slogan' },
    { test: /\bone owner\b/i, replacement: 'one owner windshield slogan' },
    { test: /\b(low mileage|low miles)\b/i, replacement: 'low miles windshield slogan' },
    { test: /\bslogans?\b/i, replacement: 'windshield slogan stickers' },
    // Decorative
    { test: /\bstar(s)?\b/i, replacement: 'windshield decorative stars' },
    { test: /\bhappy face(s)?\b/i, replacement: 'happy face decorative' },
    { test: /\bdollar sign(s)?\b/i, replacement: 'dollar sign decorative' },
    { test: /\bhang ?tag(s)?\b/i, replacement: 'rearview mirror hang tag' },
    { test: /\boval(s)?\b/i, replacement: 'windshield oval signs' },
    // Compliance
    { test: /\b(buyer'?s? guide|fac|fpc|ftc form)\b/i, replacement: 'buyers guide' },
    { test: /\b(deal jacket|deal folder)\b/i, replacement: 'deal jacket' },
    // Marketing
    { test: /\b(balloon|balon|ballon)(s|es)?\b/i, replacement: 'reusable balloon' },
    { test: /\b(feather ?flag)s?\b/i, replacement: 'feather flag' },
    { test: /\b(bow|ribbon)s?\b/i, replacement: 'premium bow' },
    { test: /\bwindshield marker(s)?\b/i, replacement: 'wide tip windshield marker' },
    { test: /\bsticker dollar(s)?\b/i, replacement: 'sticker dollars' }
  ];

  function applySynonyms(q) {
    var result = q;
    for (var i = 0; i < SYNONYMS.length; i++) {
      if (SYNONYMS[i].test.test(result)) {
        result = result.replace(SYNONYMS[i].test, SYNONYMS[i].replacement);
      }
    }
    return result.replace(/\s+/g, ' ').trim();
  }

  // ====== PARSE ======
  var WORD_NUMS = { one:1,two:2,three:3,four:4,five:5,six:6,seven:7,eight:8,nine:9,ten:10,
    eleven:11,twelve:12,fifteen:15,twenty:20,thirty:30,forty:40,fifty:50,hundred:100,dozen:12 };

  function parseTokens(text) {
    var parts = text.split(/[,;]|\s+and\s+|\s+plus\s+|\s+&\s+/i)
      .map(function (s) { return s.trim(); }).filter(Boolean);
    return parts.map(parseLine);
  }

  function parseLine(line) {
    var qty = 1, remainder = line, multiplier = 1;
    // Leading numeric qty with optional unit
    var m = line.match(/^(\d+)\s*(dozen|doz\.?|packs?|boxes?|cases?|rolls?)?\s+(?:of\s+)?(.+)/i);
    if (m) {
      qty = parseInt(m[1], 10) || 1;
      var unit = (m[2] || '').toLowerCase();
      if (unit.indexOf('dozen') === 0 || unit.indexOf('doz') === 0) multiplier = 12;
      remainder = m[3];
    } else {
      var w = line.match(/^(a|an|one|two|three|four|five|six|seven|eight|nine|ten|eleven|twelve|fifteen|twenty|thirty|forty|fifty)\s+(dozen|doz\.?|packs?|boxes?)?\s+(?:of\s+)?(.+)/i);
      if (w) {
        var k = w[1].toLowerCase();
        qty = (k === 'a' || k === 'an') ? 1 : (WORD_NUMS[k] || 1);
        var u = (w[2] || '').toLowerCase();
        if (u.indexOf('dozen') === 0 || u.indexOf('doz') === 0) multiplier = 12;
        remainder = w[3];
      }
    }
    return { qty: qty * multiplier, q: remainder.trim(), original: line };
  }

  function parseAndMatch(text) {
    var tokens = parseTokens(text);
    var promises = tokens.map(function (t, i) {
      return smartSearch(t.q).then(function (variant) {
        var matched = !!(variant.variantId && variant.price > 0);
        var row = {
          id: 'r' + Date.now() + '_' + i,
          qty: t.qty || 1,
          query: t.q,
          original: t.original,
          title: matched ? variant.title : (t.q || t.original || 'Unknown'),
          productTitle: variant.productTitle || '',
          variantTitle: variant.variantTitle || '',
          price: variant.price || 0,
          productId: variant.productId || null,
          variantId: variant.variantId || null,
          handle: variant.handle || null,
          image: variant.image || null,
          confidence: variant.confidence || 'low',
          matched: matched,
          available: variant.available !== false,
          options: variant.options || [],
          variants: variant.variants || [],
          warn: variant.available === false && matched ? 'Low stock — substitutes available' : ''
        };
        if (matched) return row;
        return getSuggestions(t.q).then(function (s) { row.suggestions = s; return row; });
      });
    });
    return Promise.all(promises);
  }

  // Smart multi-pass search: try the query as-is, then synonym-expanded, then last-2-words, then individual nouns
  function parsePrice(p) {
    if (typeof p === 'number') return p < 100 ? p : p / 100;
    if (!p) return 0;
    return parseFloat(String(p).replace(/[^0-9.]/g, '')) || 0;
  }

  var productCache = {};
  function fetchProduct(handle) {
    if (productCache[handle]) return Promise.resolve(productCache[handle]);
    return fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) { if (d) productCache[handle] = d; return d; })
      .catch(function () { return null; });
  }

  function pickVariant(product, q) {
    var variants = product.variants || [];
    if (!variants.length) return null;
    if (variants.length === 1) return variants[0];
    var qWords = q.toLowerCase().split(/\s+/).filter(function (w) { return w.length > 1; });
    var scored = variants.map(function (v) {
      var vt = ((v.title || '') + ' ' + (v.option1 || '') + ' ' + (v.option2 || '') + ' ' + (v.option3 || '')).toLowerCase();
      var s = 0;
      qWords.forEach(function (w) { if (vt.indexOf(w) !== -1) s += 1; });
      if (v.available) s += 0.5;
      return { v: v, s: s };
    });
    scored.sort(function (a, b) { return b.s - a.s; });
    return scored[0].v;
  }

  function titleScore(title, q) {
    var t = (title || '').toLowerCase();
    var s = 0;
    q.toLowerCase().split(/\s+/).forEach(function (w) { if (w.length > 1 && t.indexOf(w) !== -1) s += 1; });
    return s;
  }


  // Combined-product shortcuts — dealer shorthand maps directly to the parent product
  // with the most variants, so the dealer gets the full variant picker (color, style, qty).
  var SHORTCUT_HANDLES = [
    // Most specific first — size + numbers/sticker keyword
    { test: /\b(9\.5|9\s*1\/2|9-1\/2|9'?s)\b/i,  handle: 'windshield-number-stickers-9-5' },
    { test: /\b(7\.5|7\s*1\/2|7-1\/2|7'?s)\b/i,  handle: 'windshield-number-stickers-7-5' },
    { test: /\b(5\.5|5\s*1\/2|5-1\/2|5'?s)\b/i,  handle: 'windshield-number-stickers-5-5' },
    { test: /\b(11\.5|11\s*1\/2|11-1\/2|11'?s|super[- ]?size)\b/i,  handle: 'windshield-number-stickers-11-5' },
    { test: /\b(6\.0|6\s*\"|6[- ]inch|bubble 6)\b/i,  handle: 'windshield-number-stickers-6' },
    { test: /\b(4\.0|4\s*\"|4[- ]inch|bubble 4)\b/i,  handle: 'windshield-number-stickers-4' },
    // Slogans — any slogan keyword routes to combined parent
    { test: /\b(slogan|automatic|one[- ]owner|low[- ]miles|as[- ]is|hot[- ]buy|sale[- ]sticker|wow|reduced|loaded|special|demo|sold|new[- ]arrival|must[- ]see|financing|bhph)\b/i,  handle: 'windshield-slogan-stickers' },
    // Key tags
    { test: /\b(key[- ]?tags?|polytags?|poly[- ]?tags?|poly[- ]?key)\b/i,  handle: 'key-tags' },
    // Hang tags / ovals / decorative
    { test: /\b(hang[- ]?tags?|rear[- ]?view[- ]?(tags?|hangs?))\b/i,  handle: 'windshield-hang-tags' },
    { test: /\boval(s)?\b/i,  handle: 'windshield-oval-signs' },
    { test: /\b(stars?|decorative[- ]?sticker)\b/i,  handle: 'windshield-decorative-stickers' },
    // Marketing
    { test: /\b(feather[- ]?flag)s?\b/i,  handle: 'stock-feather-flags' },
    { test: /\b(balloon|balon)(s|es)?\b/i,  handle: 'non-helium-reusable-balloon' }
  ];

  function shortcutHandle(rawQ) {
    for (var i = 0; i < SHORTCUT_HANDLES.length; i++) {
      if (SHORTCUT_HANDLES[i].test.test(rawQ)) return SHORTCUT_HANDLES[i].handle;
    }
    return null;
  }

  function predictiveSearch(q) {
    if (!q) return Promise.resolve({});
    var url = '/search/suggest.json?q=' + encodeURIComponent(q) +
      '&resources[type]=product&resources[limit]=5&resources[options][unavailable_products]=last';
    return fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        if (!data || !data.resources || !data.resources.results || !data.resources.results.products) return null;
        var products = data.resources.results.products;
        if (!products.length) return null;
        var scored = products.map(function (p) { return { p: p, s: titleScore(p.title, q) + (p.available !== false ? 0.5 : 0) }; });
        scored.sort(function (a, b) { return b.s - a.s; });
        return scored[0].p;
      })
      .then(function (p) {
        if (!p) return {};
        return fetchProduct(p.handle).then(function (full) {
          if (!full) return {};
          var v = pickVariant(full, q);
          if (!v) return {};
          var price = parsePrice(v.price);
          if (!price) return {};
          var label = full.title;
          if (v.title && v.title !== 'Default Title') label += ' — ' + v.title;
          return {
            title: label,
            productTitle: full.title,
            handle: full.handle,
            productId: full.id,
            variantId: v.id,
            variantTitle: v.title || '',
            price: price,
            image: full.featured_image || (full.images && full.images[0]) || '',
            available: !!v.available,
            confidence: titleScore(full.title, q) > 1.5 ? 'high' : 'medium',
            options: full.options || [],
            variants: full.variants || []
          };
        });
      })
      .catch(function () { return {}; });
  }


  // Get top candidate products when no exact match — used to show "Are you looking for one of these?"
  function getSuggestions(rawQ) {
    var attempts = [rawQ, applySynonyms(rawQ)];
    var words = rawQ.split(/\s+/).filter(Boolean);
    if (words.length > 2) attempts.push(words.slice(-2).join(' '));
    if (words.length > 1) attempts.push(words[words.length - 1]);
    attempts = attempts.filter(function (a, i) { return a && attempts.indexOf(a) === i; });

    function tryNext(i, acc) {
      if (i >= attempts.length || acc.length >= 5) return Promise.resolve(acc.slice(0, 4));
      var url = '/search/suggest.json?q=' + encodeURIComponent(attempts[i]) +
        '&resources[type]=product&resources[limit]=6';
      return fetch(url, { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (data) {
          var ps = data && data.resources && data.resources.results && data.resources.results.products || [];
          ps.forEach(function (p) {
            if (acc.length < 5 && !acc.find(function (a) { return a.handle === p.handle; })) {
              acc.push({
                handle: p.handle,
                title: p.title,
                price: parsePrice(p.price),
                image: p.featured_image || p.image,
                url: p.url
              });
            }
          });
          return tryNext(i + 1, acc);
        })
        .catch(function () { return tryNext(i + 1, acc); });
    }
    return tryNext(0, []);
  }

  function smartSearch(rawQ) {
    // 1. Try shortcut handle (combined parent products) first — gives full variant picker
    var handle = shortcutHandle(rawQ);
    if (handle) {
      return fetchProduct(handle).then(function (full) {
        if (full) {
          var v = pickVariant(full, rawQ);
          if (v) {
            var price = parsePrice(v.price);
            if (price > 0) {
              var label = full.title;
              if (v.title && v.title !== 'Default Title') label += ' — ' + v.title;
              return {
                title: label, productTitle: full.title, handle: full.handle,
                productId: full.id, variantId: v.id, variantTitle: v.title || '',
                price: price, image: full.featured_image || (full.images && full.images[0]) || '',
                available: !!v.available, confidence: 'high',
                options: full.options || [], variants: full.variants || []
              };
            }
          }
        }
        // Fall through to predictive search
        return predictiveTryChain(rawQ);
      });
    }
    return predictiveTryChain(rawQ);
  }

  function predictiveTryChain(rawQ) {
    var attempts = [rawQ, applySynonyms(rawQ)];
    var words = rawQ.split(/\s+/).filter(Boolean);
    if (words.length > 2) attempts.push(words.slice(-2).join(' '));
    if (words.length > 3) attempts.push(words.slice(-3).join(' '));
    attempts = attempts.filter(function (a, idx) { return a && attempts.indexOf(a) === idx; });
    function tryNext(i) {
      if (i >= attempts.length) return Promise.resolve({});
      return predictiveSearch(attempts[i]).then(function (result) {
        if (result && result.variantId && result.price > 0) return result;
        return tryNext(i + 1);
      });
    }
    return tryNext(0);
  }



  // ====== RENDER ======
  function renderRows() {
    listRows.innerHTML = '';
    if (!state.rows.length) {
      // No rows? Hide the entire list section and bring back the intro.
      if (listSection) listSection.hidden = true;
      if (intro) intro.hidden = false;
      updateSubtotal();
      return;
    }
    state.rows.forEach(function (row) {
      var div = document.createElement('div');
      div.className = 'aa-row' + (row.matched ? '' : ' aa-row--nomatch');
      div.dataset.id = row.id;
      var conf = '';
      if (row.matched && row.confidence === 'medium') {
        conf = '<span class="aa-row__conf" title="I picked this — confirm or edit">?</span>';
      }
      var priceTxt = row.matched ? '$' + (row.price * row.qty).toFixed(2) : '—';
      var variantPicker = '';
      if (row.matched && row.variants && row.variants.length > 1) {
        variantPicker = buildVariantPicker(row);
      }
      var suggList = '';
      if (!row.matched && row.suggestions && row.suggestions.length) {
        suggList = buildSuggestionList(row);
      }
      var refineBtn = (!row.matched ? '<button type="button" class="aa-row__refine" data-refine="' + escapeHTML(row.query || row.original) + '">Refine search</button>' : '');
      div.innerHTML =
        '<input class="aa-row__check" type="checkbox"' + (row.matched ? ' checked' : '') + ' aria-label="Include in order">' +
        '<input class="aa-row__qty" type="number" min="1" value="' + row.qty + '" aria-label="Quantity">' +
        '<div class="aa-row__body">' +
          '<div class="aa-row__title">' + escapeHTML(row.title) + conf + '</div>' +
          (row.variantTitle ? '<div class="aa-row__variant">' + escapeHTML(row.variantTitle) + '</div>' : '') +
          variantPicker +
          suggList +
          refineBtn +
        '</div>' +
        '<div class="aa-row__price">' + priceTxt + '</div>' +
        '<button type="button" class="aa-row__remove" aria-label="Remove">&times;</button>';
      listRows.appendChild(div);

      // Wire row interactions
      div.querySelector('.aa-row__check').addEventListener('change', function (e) {
        row._unchecked = !e.target.checked;
        updateSubtotal();
      });
      div.querySelector('.aa-row__qty').addEventListener('change', function (e) {
        var n = parseInt(e.target.value, 10) || 1;
        row.qty = n;
        if (row.matched) div.querySelector('.aa-row__price').textContent = '$' + (row.price * row.qty).toFixed(2);
        updateSubtotal();
      });
      div.querySelector('.aa-row__remove').addEventListener('click', function () {
        state.rows = state.rows.filter(function (r) { return r.id !== row.id; });
        renderRows();
      });
      // Refine button
      var rb = div.querySelector('.aa-row__refine');
      if (rb) rb.addEventListener('click', function () {
        var newQ = prompt('Refine search — what are you looking for?', row.query || row.original);
        if (!newQ) return;
        setMood('thinking');
        smartSearch(newQ).then(function (m) {
          if (m.variantId && m.price > 0) {
            Object.assign(row, {
              variantId: m.variantId, productId: m.productId, title: m.title, productTitle: m.productTitle,
              price: m.price, variantTitle: m.variantTitle, image: m.image, available: m.available,
              handle: m.handle, matched: true, query: newQ, options: m.options, variants: m.variants,
              suggestions: null
            });
            renderRows();
            setMood('done');
          } else {
            getSuggestions(newQ).then(function (s) { row.suggestions = s; row.query = newQ; renderRows(); setMood('sorry'); });
          }
        });
      });
      // Variant picker dropdowns
      div.querySelectorAll('.aa-vp-select').forEach(function (sel) {
        sel.addEventListener('change', function () { applyVariantChange(row, div); });
      });
      // Suggestion-card clicks
      div.querySelectorAll('.aa-sugg-card').forEach(function (card) {
        card.addEventListener('click', function () {
          var handle = card.dataset.handle;
          fetchProduct(handle).then(function (full) {
            if (!full) return;
            var v = pickVariant(full, row.query || row.original);
            if (!v) return;
            var price = parsePrice(v.price);
            var label = full.title + (v.title && v.title !== 'Default Title' ? ' — ' + v.title : '');
            Object.assign(row, {
              variantId: v.id, productId: full.id, title: label, productTitle: full.title,
              price: price, variantTitle: v.title || '', image: full.featured_image,
              available: !!v.available, handle: full.handle, matched: true,
              options: full.options || [], variants: full.variants || [], suggestions: null
            });
            renderRows();
            setMood('done');
          });
        });
      });
    });
    var matched = state.rows.filter(function (r) { return r.matched && !r._unchecked; }).length;
    addCartBtn.disabled = matched === 0;
    orderNowBtn.disabled = matched === 0;
    matchCountEl.textContent = '(' + matched + ' of ' + state.rows.length + ' matched)';
    updateSubtotal();
  }

  function buildVariantPicker(row) {
    if (!row.options || !row.options.length || !row.variants || row.variants.length < 2) return '';
    var dims = row.options.map(function (optName, idx) {
      var values = [];
      row.variants.forEach(function (v) {
        var val = v['option' + (idx + 1)];
        if (val && values.indexOf(val) === -1) values.push(val);
      });
      var currentVariant = row.variants.find(function (v) { return v.id === row.variantId; }) || row.variants[0];
      var current = currentVariant ? currentVariant['option' + (idx + 1)] : '';
      var opts = values.map(function (val) {
        return '<option value="' + escapeHTML(val) + '"' + (val === current ? ' selected' : '') + '>' + escapeHTML(val) + '</option>';
      }).join('');
      return '<label class="aa-vp-label"><span>' + escapeHTML(optName) + '</span><select class="aa-vp-select" data-dim="' + idx + '">' + opts + '</select></label>';
    }).join('');
    return '<div class="aa-vp-wrap aa-vp-wrap--always"><div class="aa-vp-label-row">Choose options:</div><div class="aa-vp-panel aa-vp-panel--always">' + dims + '</div></div>';
  }

  function applyVariantChange(row, div) {
    var selects = div.querySelectorAll('.aa-vp-select');
    var picks = [];
    selects.forEach(function (s) { picks.push(s.value); });
    // Find matching variant
    var match = row.variants.find(function (v) {
      for (var i = 0; i < picks.length; i++) {
        if ((v['option' + (i + 1)] || '') !== picks[i]) return false;
      }
      return true;
    });
    if (match) {
      row.variantId = match.id;
      row.variantTitle = match.title || picks.join(' / ');
      row.price = parsePrice(match.price);
      row.available = !!match.available;
      row.title = row.productTitle + ' — ' + row.variantTitle;
      renderRows();
    }
  }

  function buildSuggestionList(row) {
    if (!row.suggestions || !row.suggestions.length) return '';
    var top = row.suggestions.slice(0, 3);
    var cards = top.map(function (s) {
      var img = s.image ? '<img src="' + escapeHTML(s.image) + '" alt="" class="aa-sugg-card__img">' : '<span class="aa-sugg-card__noimg"></span>';
      var p = s.price ? '$' + s.price.toFixed(2) : '';
      return '<button type="button" class="aa-sugg-card" data-handle="' + escapeHTML(s.handle) + '">' +
        img + '<span class="aa-sugg-card__title">' + escapeHTML(s.title) + '</span>' +
        (p ? '<span class="aa-sugg-card__price">' + p + '</span>' : '') +
        '</button>';
    }).join('');
    return '<div class="aa-sugg-wrap"><div class="aa-sugg-prompt">Are you looking for one of these?</div><div class="aa-sugg-cards">' + cards + '</div></div>';
  }

  
  function updateSubtotal() {
    var total = state.rows.reduce(function (s, r) {
      return (r._unchecked || !r.matched) ? s : s + (r.price * r.qty);
    }, 0);
    subtotalEl.textContent = '$' + total.toFixed(2);
  }

  function escapeHTML(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;' }[c];
    });
  }

  // ====== CHAT REFINEMENT ======
  chatForm.addEventListener('submit', function (e) {
    e.preventDefault();
    var msg = chatInput.value.trim();
    if (!msg) return;
    chatInput.value = '';
    addChat(msg, 'user');
    setMood('thinking');
    handleRefinement(msg).then(function (reply) {
      addChat(reply, 'bot');
      setMood('happy');
    });
  });

  function addChat(text, who) {
    var d = document.createElement('div');
    d.className = 'aa-chat-msg aa-chat-msg--' + who;
    d.innerHTML = text;
    chatLog.appendChild(d);
    chatLog.scrollTop = chatLog.scrollHeight;
  }

  function handleRefinement(msg) {
    var lower = msg.toLowerCase();
    var rm = lower.match(/^(remove|delete|drop|take off)\s+(?:the\s+)?(.+)/);
    if (rm) {
      var q = rm[2], before = state.rows.length;
      state.rows = state.rows.filter(function (r) {
        return r.name.toLowerCase().indexOf(q) === -1 && (r.query || '').toLowerCase().indexOf(q) === -1;
      });
      renderRows();
      var removed = before - state.rows.length;
      return Promise.resolve(removed > 0 ? 'Removed ' + removed + ' item' + (removed===1?'':'s') + '.' : 'Couldn&rsquo;t find that to remove.');
    }
    var ch = lower.match(/^(?:change|swap|make|switch)\s+(?:the\s+)?(.+?)\s+(?:to|for|into)\s+(.+)/);
    if (ch) {
      var target = ch[1], replacement = ch[2];
      var row = state.rows.find(function (r) { return r.name.toLowerCase().indexOf(target) !== -1 || (r.query || '').toLowerCase().indexOf(target) !== -1; });
      if (!row) return Promise.resolve('I couldn&rsquo;t find &ldquo;' + target + '&rdquo; in your list.');
      var newQuery = target + ' ' + replacement;
      return smartSearch(newQuery).then(function (match) {
        if (match.productId && match.price > 0) {
          Object.assign(row, { name: match.title, variant: match.variantTitle, price: match.price,
            productId: match.productId, variantId: match.variantId, handle: match.handle,
            image: match.image, available: match.available, query: newQuery, matched: true,
            warn: match.available === false ? 'Low stock — substitutes available' : '' });
          renderRows();
          return 'Switched to ' + match.title + '.';
        }
        return 'I couldn&rsquo;t find a &ldquo;' + replacement + '&rdquo; version of that.';
      });
    }
    var qty = lower.match(/^(?:make|set|change\s+(?:qty|quantity)\s+of)\s+(?:the\s+)?(.+?)\s+(?:to|=)?\s*(\d+)/);
    if (qty) {
      var name = qty[1], n = parseInt(qty[2], 10);
      var row2 = state.rows.find(function (r) { return r.name.toLowerCase().indexOf(name) !== -1 || (r.query || '').toLowerCase().indexOf(name) !== -1; });
      if (row2) { row2.qty = n; renderRows(); return Promise.resolve('Updated to ' + n + '.'); }
      return Promise.resolve('I couldn&rsquo;t find that item.');
    }
    var add = lower.match(/^(?:add|throw in|include)\s+(.+)/);
    if (add) {
      return parseAndMatch(add[1]).then(function (newRows) {
        if (!newRows.length) return 'I couldn&rsquo;t find that in the catalog.';
        state.rows = state.rows.concat(newRows);
        renderRows();
        var matched = newRows.filter(function (r) { return r.matched; }).length;
        return 'Added ' + matched + ' of ' + newRows.length + ' item' + (newRows.length===1?'':'s') + '.';
      });
    }
    return parseAndMatch(msg).then(function (newRows) {
      if (!newRows.length) return 'I couldn&rsquo;t figure that out. Try &ldquo;remove X&rdquo;, &ldquo;change X to Y&rdquo;, or &ldquo;add N X&rdquo;.';
      state.rows = state.rows.concat(newRows);
      renderRows();
      return 'Added that.';
    });
  }

  function maybeShowSuggest() {
    if (!state.rows.length) { suggestBox.hidden = true; return; }
    var has = function (term) {
      return state.rows.some(function (r) { return ((r.name || '') + ' ' + (r.query || '')).toLowerCase().indexOf(term) !== -1; });
    };
    var suggestions = [];
    if (has('balloon')) suggestions.push('matching window-clip holders');
    if (has('number') && !has('marker')) suggestions.push('wide-tip windshield markers');
    if (has('sale') || has('special')) suggestions.push('arch banners & feather flags');
    if (!suggestions.length) { suggestBox.hidden = true; return; }
    suggestBox.hidden = false;
    suggestBox.innerHTML =
      '<strong>Dealers who ordered this also grab:</strong> ' + suggestions.join(', ') + '. ' +
      '<button type="button" id="aa-add-suggest">Add to list</button>';
    var addS = document.getElementById('aa-add-suggest');
    if (addS) addS.addEventListener('click', function () {
      parseAndMatch(suggestions.join(', ')).then(function (newRows) {
        state.rows = state.rows.concat(newRows);
        renderRows(); addChat('Added the suggested items.', 'bot');
      });
      suggestBox.hidden = true;
    });
  }

  function checkedLineItems() {
    return state.rows.filter(function (r) { return r.matched && !r._unchecked && r.variantId; })
      .map(function (r) { return { id: r.variantId, quantity: r.qty }; });
  }

  function addToCart(redirect) {
    var items = checkedLineItems();
    if (!items.length) { setMood('sorry'); addChat('Nothing matched yet — refine the items that show &ldquo;couldn&rsquo;t find&rdquo; before adding to cart.', 'bot'); return; }
    addCartBtn.disabled = true; orderNowBtn.disabled = true;
    setMood('thinking');
    fetch('/cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) { return r.json(); })
      .then(function () {
        setMood('happy');
        if (redirect === 'checkout') window.location.href = '/checkout';
        else if (redirect === 'cart') window.location.href = '/cart';
        else {
          addChat('Added ' + items.length + ' items to your cart.', 'bot');
          var dt = document.querySelector('[data-cart-drawer], .cart-drawer, summary[aria-label="Cart"]');
          if (dt) dt.click();
        }
      })
      .catch(function () {
        addCartBtn.disabled = false; orderNowBtn.disabled = false;
        setMood('sorry');
        addChat('Something went wrong adding to cart. Try one item at a time.', 'bot');
      });
  }
  addCartBtn.addEventListener('click', function () { addToCart('cart'); });
  orderNowBtn.addEventListener('click', function () { addToCart('checkout'); });

  function getTemplates() { try { return JSON.parse(localStorage.getItem('askAngie.templates') || '[]'); } catch (e) { return []; } }
  function saveTemplates(list) { try { localStorage.setItem('askAngie.templates', JSON.stringify(list)); } catch (e) {} }
  function renderTemplates() {
    var list = getTemplates();
    if (!list.length) { templatesContainer.hidden = true; return; }
    templatesContainer.hidden = false;
    templatesList.innerHTML = '';
    list.forEach(function (tpl) {
      var d = document.createElement('div'); d.className = 'aa-template-card';
      d.innerHTML = '<div><div class="aa-template-card__name">' + escapeHTML(tpl.name) + '</div>' +
        '<div class="aa-template-card__count">' + tpl.rows.length + ' items · ' + new Date(tpl.created).toLocaleDateString() + '</div></div>' +
        '<button type="button">Load</button>';
      d.querySelector('button').addEventListener('click', function () {
        state.rows = tpl.rows.map(function (r) { return Object.assign({}, r, { id: 'r' + Date.now() + Math.random() }); });
        intro.hidden = true; listSection.hidden = false; renderRows(); maybeShowSuggest(); setMood('done');
      });
      templatesList.appendChild(d);
    });
  }
  saveBtn.addEventListener('click', function () {
    if (!state.rows.length) { addChat('Build your order first, then save.', 'bot'); return; }
    var name = prompt('Name this saved order (e.g., "Monthly restock kit"):');
    if (!name) return;
    var list = getTemplates();
    list.unshift({ name: name, rows: state.rows.filter(function (r) { return !r._unchecked && r.matched; }), created: Date.now() });
    saveTemplates(list.slice(0, 20));
    addChat('Saved "' + name + '" — load it from the start screen next time.', 'bot');
  });

  startOverBtn.addEventListener('click', function () {
    state = { rows: [] };
    inputEl.value = ''; chatLog.innerHTML = ''; suggestBox.hidden = true;
    listSection.hidden = true; intro.hidden = false;
    setMood('idle');
  });

  console.log('[Ask Angie v2] ready');

  // Move hero card into homepage hero section (banner__content) so it sits above "High Quality..." text
  function injectHero() {
    var hero = document.getElementById('ask-angie-hero');
    if (!hero) return;
    var box = document.querySelector('.banner__box');
    if (box && hero.parentNode !== box) {
      box.insertBefore(hero, box.firstChild);
      hero.classList.add('aa-hero--injected', 'aa-hero--in-box');
      // Force the box to flex column so hero stacks ABOVE h2
      box.style.display = 'flex';
      box.style.flexDirection = 'column';
      box.style.alignItems = 'center';
      box.style.gap = '14px';
      return;
    }
    var content = document.querySelector('.banner__content');
    if (content && hero.parentNode !== content) {
      content.insertBefore(hero, content.firstChild);
      hero.classList.add('aa-hero--injected');
      content.style.display = 'flex';
      content.style.flexDirection = 'column';
      content.style.alignItems = 'center';
      return;
    }
    hero.classList.add('aa-hero--fallback');
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', injectHero);
  } else {
    injectHero();
  }

})();
// === v4 click-to-expand variant panel ===
document.addEventListener('click', function (e) {
  var t = e.target;
  if (t && t.classList && t.classList.contains('aa-vp-toggle')) {
    var wrap = t.closest('.aa-vp-wrap');
    if (wrap) wrap.classList.toggle('open');
  }
});
